enum ImageCompression {
  DotNetJpeg411 = 0,
  WICHDPhoto = 1,
  DotNetPng = 2,
  DotNetTiff = 3,
  DotNetGif = 4,
  DotNetBmp = 5,
}

export default ImageCompression;
